<section class="Receipt gray_baack subb-admin" >
	<div class="container">
	   <h2 class="title text-center"> Sub admins </h2>
		<div class="row mt-4 pt-4">

		 		<div class="col-md-12 mb-4">
				    <div class="Sub_admins_on">
						<div class="Sub_admins">
							<div class="media position-relative sub_image" *ngFor="let act of actions">
							  <img loading="lazy" [src]="adminImg" class="mr-3" alt="..." (error)="onImgError($event)">
							  <div class="media-body">
								<h5 class="">{{name}}  <br/> <span> {{act.created*1000 | date :'fullDate'}}</span></h5>
								<p>{{act.action}}<a class="del_cat" (click)="deleteCust(act.customerId)" *ngIf="act.isCustomer == 1 && act.isCustomerDeleted == 0"> <img loading="lazy" src="../../../../assets/images/del.png" alt="..."> </a></p>
							  </div>
							</div>
						</div>
						<a class="view_mo" [routerLink]="['/admin/profile']"> View More </a>
				    </div>
				</div>
    </div>
	</div>
</section>
